module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "western",
    attrs: {
      "id": "calibre_pb_2"
    }
  }, [_c('p', {
    staticClass: "western2"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_vm._v("A PERMUTED PRESS BOOK")]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_vm._v("Published at Smashwords")]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_vm._v("ISBN: 978-1-68261-116-6")]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_vm._v("ISBN (eBook): 978-1-68261-117-3")]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_vm._v("FAULT LINE")]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_vm._v("The Journal Book 5")]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_vm._v("© 2016 by Deborah D. Moore")]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_vm._v("All Rights Reserved")]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_vm._v("Cover art by Christian Bentulan")]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_vm._v("This book is a work of fiction. People,\nplaces, events, and situations are the product of the author's\nimagination. Any resemblance to actual persons, living or dead, or\nhistorical events, is purely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_vm._v("No part of this book may be reproduced,\nstored in a retrieval system, or transmitted by any means without\nthe written permission of the author and publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "tmp_81917b76c0dc0690a3d5075948c70f3d_BuZtIk_html_m200a9aff.jpg",
      "id": "graphics1",
      "src": "tmp_81917b76c0dc0690a3d5075948c70f3d_BuZtIk_html_m200a9aff.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_vm._v("Permuted Press")]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_vm._v("109 International Drive, Suite 300")]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_vm._v("Franklin, TN 37067")]), _vm._v(" "), _c('p', {
    staticClass: "c5"
  }, [_c('span', {
    staticClass: "c6"
  }, [_c('a', {
    attrs: {
      "href": "http://permutedpress.com/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "c7"
  }, [_vm._v("http://permutedpress.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "c4"
  }, [_vm._v("Also in The Journal series:")]), _vm._v(" "), _c('p', {
    staticClass: "western2"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western2"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western2"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western2"
  }, [_c('br', {
    staticClass: "calibre2"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12b54250","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp_81917b76c0dc0690a3d5075948c70f3d_BuZtIk.ch.fixed.fc.tidied.stylehacked.xfixed_split_002.vue
// module id = 66
// module chunks = 0